import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./madurai.css";
import axios from "axios";
const APIURL = process.env.REACT_APP_BASE_URL;


export default function KundaliResult() {
    const [planets, setPlanets] = useState([]);
    const location = useLocation();
    const state = location.state;
    const data = [
        { sign: "Aries", msg: "Positive" },

    ];

    const charts = async () => {
        try {
            const [year, month, day] = state.dob.split("-").map(Number);
            const [hour, minute] = state.tob.split(":").map(Number);
            const postData = {
                name: state.name,
                year,
                month,
                day,
                hour,
                minute,
            }
            const response = await axios.post(`${APIURL}/kundali`,postData);
            console.log(state.name + "data==>", response.data.planets);
            setPlanets(response.data.planets);
            //return response.data;
        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        // Fetch the data
        charts();

        //setPosts(data);
    }, []);

    const getRasi = (index) => {
        let rasi = planets.filter(f => f.rasi.no === index);
        // console.log(index + "====>>", rasi)
        if (rasi.length > 0) {
            //   console.log("====>", rasi[0])
            return rasi.map(m => m.planet.enShort).join(" ");
        } else {
            return "";
        }
    }

    const isRasiASC = (index) => {
        let rasi = planets.filter(f => f.rasi.no === index);
        //console.log(index + "====>>", rasi)
        if (rasi.length > 0) {
            //  console.log("====>", rasi[0])
            return rasi.some(m => m.planet.enShort === 'Asc');;
        } else {
            return false;
        }
    }


    const getNavamsa = (index) => {
        let rasi = planets.filter(f => f.navansa === index);
        //console.log(index + "====>>", rasi)
        if (rasi.length > 0) {
            //  console.log("====>", rasi[0])
            return rasi.map(m => m.planet.enShort).join(" ");
        } else {
            return "";
        }
    }

    const isNavamsaASC = (index) => {
        let rasi = planets.filter(f => f.navansa === index);
        //console.log(index + "====>>", rasi)
        if (rasi.length > 0) {
            //console.log("====>", rasi[0])
            return rasi.some(m => m.planet.enShort === "Asc");
        } else {
            return false;
        }
    }

    return (
        <div >
            <h2 className="section-title">Daily Horoscope</h2>

            <p className="description">
                This astrology system follows the traditional south Indian Thirukanitham method, using Lahiri Ayanamsa
                for precise sidereal planetary calculations. All planetary positions, charts, and predictions are computed based
                on the Gregorian calendar and aligned with classical Vedic astrology principles. The approach emphasizes accuracy,
                authenticity, and adherence to time-tested astronomical calculations.<br />
            </p>

            <div>
                <table className="tablecard" >
                    <thead>
                        <tr>
                            <td className="tablecardCell">
                                <div className="box">
                                    <h3>Planets</h3>
                                </div>
                            </td>
                            <td className="tablecardCell">
                                <div className="box">
                                    <h3>Degrees</h3>
                                </div>
                            </td>
                            <td className="tablecardCell">
                                <div className="box">
                                    <h3>Rasi</h3>
                                </div>
                            </td>
                            <td className="tablecardCell">
                                <div className="box">
                                    <h3>Rasi Lord</h3>
                                </div>
                            </td>
                            <td className="tablecardCell">
                                <div className="box">
                                    <h3>Nakshatra</h3>
                                </div>
                            </td>
                            <td className="tablecardCell">
                                <div className="box">
                                    <h3>Nakshatra Lord</h3>
                                </div>
                            </td>
                            <td className="tablecardCell">
                                <div className="box">
                                    <h3>Padam</h3>
                                </div>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        {planets.map((planet) => (
                            <tr key={planet.planet.no}>
                                <td className="tablecardCell">
                                    <div className="box">{planet.planet.enFull}
                                    </div></td>
                                <td className="tablecardCell">
                                    <div className="box">{planet.longitudeDMS}
                                    </div></td>
                                <td className="tablecardCell">
                                    <div className="box">{planet.rasi.rasiEn}
                                    </div></td>
                                <td className="tablecardCell">
                                    <div className="box">{planet.rasi.lord}
                                    </div></td>
                                <td className="tablecardCell">
                                    <div className="box">{planet.nakshatra.en}
                                    </div></td>
                                <td className="tablecardCell">
                                    <div className="box">{planet.nakshatra.lordEn}
                                    </div></td>
                                <td className="tablecardCell">
                                    <div className="box">{planet.pada}
                                    </div></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="chartboxmain">
                {planets &&
                    <div>
                        <table>
                            <tbody>
                                <tr>
                                    <td className="tablecardCell">
                                        <div className={isRasiASC(12) ? "chartboxASC" : "chartbox"}>{getRasi(12)}</div>
                                    </td>
                                    <td className="tablecardCell">
                                        <div className={isRasiASC(1) ? "chartboxASC" : "chartbox"}>{getRasi(1)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isRasiASC(2) ? "chartboxASC" : "chartbox"}>{getRasi(2)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isRasiASC(3) ? "chartboxASC" : "chartbox"}>{getRasi(3)}</div></td>
                                </tr>
                                <tr>
                                    <td className="tablecardCell">
                                        <div className={isRasiASC(11) ? "chartboxASC" : "chartbox"}>{getRasi(11)}</div></td>
                                    <td className="tablecardCell" rowSpan="2" colSpan="2">
                                        <div className="chartboxcenter">Rasi</div></td>
                                    <td className="tablecardCell">
                                        <div className={isRasiASC(4) ? "chartboxASC" : "chartbox"}>{getRasi(4)}</div></td>
                                </tr>
                                <tr>
                                    <td className="tablecardCell">
                                        <div className={isRasiASC(10) ? "chartboxASC" : "chartbox"}>{getRasi(10)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isRasiASC(5) ? "chartboxASC" : "chartbox"}>{getRasi(5)}</div></td>
                                </tr>
                                <tr>
                                    <td className="tablecardCell">
                                        <div className={isRasiASC(9) ? "chartboxASC" : "chartbox"}>{getRasi(9)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isRasiASC(8) ? "chartboxASC" : "chartbox"}>{getRasi(8)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isRasiASC(7) ? "chartboxASC" : "chartbox"}>{getRasi(7)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isRasiASC(6) ? "chartboxASC" : "chartbox"}>{getRasi(6)}</div></td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                }


                {planets &&
                    <div>
                        <table>
                            <tbody>
                                <tr>
                                    <td className="tablecardCell">
                                        <div className={isNavamsaASC(12) ? "chartboxASC" : "chartbox"}>{getNavamsa(12)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isNavamsaASC(1) ? "chartboxASC" : "chartbox"}>{getNavamsa(1)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isNavamsaASC(2) ? "chartboxASC" : "chartbox"}>{getNavamsa(2)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isNavamsaASC(3) ? "chartboxASC" : "chartbox"}>{getNavamsa(3)}</div></td>
                                </tr>
                                <tr>
                                    <td className="tablecardCell"><
                                        div className={isNavamsaASC(11) ? "chartboxASC" : "chartbox"}>{getNavamsa(11)}</div></td>
                                    <td className="tablecardCell" rowSpan="2" colSpan="2">
                                        <div className="chartboxcenter">Navamsa</div></td>
                                    <td className="tablecardCell">
                                        <div className={isNavamsaASC(4) ? "chartboxASC" : "chartbox"}>{getNavamsa(4)}</div></td>
                                </tr>
                                <tr>
                                    <td className="tablecardCell">
                                        <div className={isNavamsaASC(10) ? "chartboxASC" : "chartbox"}>{getNavamsa(10)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isNavamsaASC(5) ? "chartboxASC" : "chartbox"}>{getNavamsa(5)}</div></td>
                                </tr>
                                <tr>
                                    <td className="tablecardCell">
                                        <div className={isNavamsaASC(9) ? "chartboxASC" : "chartbox"}>{getNavamsa(9)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isNavamsaASC(8) ? "chartboxASC" : "chartbox"}>{getNavamsa(8)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isNavamsaASC(7) ? "chartboxASC" : "chartbox"}>{getNavamsa(7)}</div></td>
                                    <td className="tablecardCell">
                                        <div className={isNavamsaASC(6) ? "chartboxASC" : "chartbox"}>{getNavamsa(6)}</div></td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                }

            </div>
        </div>


    );
}